import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all teamses
export const getTeams = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/teams`);
    return response.data;
  } catch (error) {
    console.error("Error fetching teams:", error.response?.data || error);
    throw error;
  }
};

// GET a single teams
export const getTeamsById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/teams/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching teams:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new teams
export const createTeams = async (teamsData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/teams`, teamsData);
    return response.data;
  } catch (error) {
    console.error("Error creating teams:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing teams
export const updateTeams = async (id, teamsData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/teams/${id}`, teamsData);
    return response.data;
  } catch (error) {
    console.error("Error updating teams:", error.response?.data || error);
    throw error;
  }
};

// DELETE a teams
export const deleteTeams = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/teams/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting teams:", error.response?.data || error);
    throw error;
  }
};

// CHECK for duplicate team name
export const checkDuplicateTeams = async (name, excludeId) => {
  try {
    const params = new URLSearchParams();
    if (name) params.append('name', name);
    if (excludeId) params.append('excludeId', excludeId);
    const response = await axiosInstance.get(
      `${API_URL}/teams/check-duplicate?${params.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error checking teams:',
      error.response?.data || error
    );
    throw error;
  }
};
